import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";

const IntegrationOC = ({ completeOrder, messageOrder, text = "Ordenes de Compra" }) => {
	const contentClassName = [classes.content, completeOrder ? classes.complete : classes.inProcess].filter(Boolean).join(" ");

	return (
		<div className={contentClassName}>
			<div>
				{`Obteniendo ${text}`} <br />
				{messageOrder && <small>{messageOrder}</small>}
			</div>
			<div>
				{!completeOrder && <Fetching topMargin={"0px"} />}
				{completeOrder && messageOrder === "" && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrder && messageOrder !== "" && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationOC;
